import {
  DbotEventDispatcher,
  DecisionContext,
  DecisionTypeHandler,
} from "@/dbot/common/commonDomain";
import {
  AcquireOwnSharesPowerOfAttorney,
  AcquireOwnSharesPowerOfAttorneyForm,
} from "./acquireOwnSharesPowerOfAttorneyDomain";
import { DecisionType } from "@/common/decisions";

export function initNewForm(
  _dispatch: DbotEventDispatcher,
  context: DecisionContext<AcquireOwnSharesPowerOfAttorney>,
  data?: AcquireOwnSharesPowerOfAttorney,
): AcquireOwnSharesPowerOfAttorneyForm {
  return new AcquireOwnSharesPowerOfAttorneyForm(context, data);
}

export function applyForm(
  form: AcquireOwnSharesPowerOfAttorneyForm,
): AcquireOwnSharesPowerOfAttorney {
  return {
    type: DecisionType.acquireOwnSharesPowerOfAttorney,
    calculateShareCapitalFromShares: form.calculateShareCapitalFromShares.value,
    shareCapitalValue: form.shareCapitalValue.parsedValue ?? 0,
    minimumSharePrice: form.minimumSharePrice.parsedValue ?? 0,
    maximumSharePrice: form.maximumSharePrice.parsedValue ?? 0,
    isProportionallyAdjusted: form.isProportionallyAdjusted.value ?? false,
    otherProperties: form.otherProperties.map((t) => ({
      language: t.locale,
      text: t.model.validatedValue,
    })),
    shareCapitalDuration: form.shareCapitalDuration.value,
    shareCapitalDurationMonths: form.shareCapitalDurationMonths.parsedValue,
  };
}

export function validate(form: AcquireOwnSharesPowerOfAttorneyForm) {
  return form.validate();
}

export function isValid(form: AcquireOwnSharesPowerOfAttorneyForm) {
  return form.isValid;
}

export const acquireOwnSharesPowerOfAttorneyHandler: DecisionTypeHandler<
  DecisionType.acquireOwnSharesPowerOfAttorney,
  AcquireOwnSharesPowerOfAttorney,
  AcquireOwnSharesPowerOfAttorneyForm
> = {
  type: DecisionType.acquireOwnSharesPowerOfAttorney,
  initNewForm,
  isValid,
  validate,
  applyForm,
};
